import { baseURL } from "../../configurations/environment";
import Axios from "axios";

export const getStartedData = async (form) => {
  let requestURL = baseURL + `/api/facebook/app-info`;
  let responseResult = {
    status: "",
    message: "",
    data: "",
  };
  await Axios.get(requestURL)
    .then((response) => {
      responseResult = {
        status: true,
        message: response.message && response.message,
        data: response.data && response.data,
      };
    })
    .catch((error) => {
      responseResult = {
        status: false,
        message: error.response?.data?.message,
      };
    });
  return responseResult;
};
